module.exports = __webpack_public_path__ + "img/dancing_panda2.b13ba671.gif";